/**
 * Hand-authored design-system icon (not sourced from @central-icons-react).
 * Kept in the generated icons folder using the `.gen` suffix so the barrel's
 * import convention and the generator's index rebuild both pick it up.
 *
 * A filled status marker for info surfaces (Banner, Toast). The circle fills
 * with `currentColor`; the "i" glyph is a separate solid white path so it stays
 * white on any background or theme (the generated `IconCircleInfo` filled
 * variant knocks the glyph out instead, which shows the dark surface in dark
 * mode). Part of the status-marker set alongside `IconErrorDiamond`.
 */

import { memo } from 'react'

import { cn } from '#lib/cn'

import { type IconProps, IconSize, iconSizeValues } from '../types'

export const IconInfoCircle = memo(function IconInfoCircle({
  size = IconSize.Medium,
  title,
  className,
  ref,
  ...props
}: IconProps) {
  return (
    <svg
      width={`${iconSizeValues[size]}px`}
      height={`${iconSizeValues[size]}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!title}
      aria-label={title}
      className={cn('shrink-0', className)}
      ref={ref}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
        fill="currentColor"
      />
      <path
        d="M10 11C10 10.5858 10.3358 10.25 10.75 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11L12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25L11.25 11.75H10.75C10.3358 11.75 10 11.4142 10 11ZM12 7.25C11.5858 7.25 11.25 7.58579 11.25 8C11.25 8.41421 11.5858 8.75 12 8.75C12.4142 8.75 12.75 8.41421 12.75 8C12.75 7.58579 12.4142 7.25 12 7.25Z"
        fill="white"
      />
    </svg>
  )
})
